import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { ChatType } from 'app/features/ai-chat/models/chat-interface';
import { navigation } from 'app/navigation/navigation';
import { DevSettingsService } from 'core/services/dev-settings.service';
import { PrismaDynamicEnv } from 'core/services/ian-core-singleton.service';

@Component({
  selector: 'vertical-layout-1',
  templateUrl: './layout-1.component.html',
  styleUrls: ['./layout-1.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;

  //Espera que carge la pantalla principal
  @Input() contentReady = false;

  blockScreen = false;

  // Panel AI state management
  firstOpenedPanel = false;

  // Expose ChatType enum for template
  ChatType = ChatType;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseSidebarService: FuseSidebarService,
    private configFlags: DevSettingsService,
    private prismaDynamicEnv: PrismaDynamicEnv
  ) {
    // Set the defaults
    this.navigation = navigation;

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.fuseConfig = config;
    });

    // Determinar el contexto basado en si tenemos listeners en onFirstOpen
    // Usamos setTimeout para asegurar que Angular haya terminado de configurar los bindings
    setTimeout(() => {
      if (this.dataBricksGenieIsEnabled()) {
        try {
          // Suscribirse a eventos del sidebar para detectar cuando se abre el panel
          this._fuseSidebarService.getSidebar('quickPanelAi').openedChanged.subscribe(isOpen => {
            if (isOpen) {
              this.onFirstOpenPanel();
            } else {
              // Opcionalmente resetear el estado cuando se cierre el panel
              this.resetPanelState();
            }
          });
        } catch (error) {
          console.warn('No se pudo acceder al sidebar quickPanelAi:', error);
        }
      }
    }, 0);
  }

  changeBlock(value) {
    this.blockScreen = value;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  dataBricksGenieIsEnabled() {
    return this.prismaDynamicEnv.getConf('brandCustomization.dataBricksGenieConfig.ENABLED') || false;
  }

  shouldShowChatTypeSelector() {
    return this.prismaDynamicEnv.getConf('brandCustomization.featuresEnabled.blocksEnabled.PRISMA-ASSISTANT-AI-DATA-CHAT-DEMO') || false;
  }

  /**
   * Handle first time opening the AI panel
   * This should be called when the panel is opened for the first time
   */
  onFirstOpenPanel() {
    if (this.firstOpenedPanel) return;
    this.firstOpenedPanel = true;
  }

  /**
   * Reset the panel state (for when panel is closed and reopened)
   */
  resetPanelState() {
    this.firstOpenedPanel = false;
  }
}
